export const UploadImage = ({ images, handleImageUpload, handleRemoveImage }) => {
  return (
    <div className='upload-section'>
      <div className='image-grid'>
        {images.map(({ id, preview }) => (
          <div key={id} className='image-preview'>
            <img src={preview} alt='업로드된 이미지' />
            <button className='remove-button' onClick={() => handleRemoveImage(id)} type='button'>
              ×
            </button>
          </div>
        ))}
        {images.length < 5 && (
          <label className='add-image-box'>
            <div className='plus-icon'>+</div>
            <span>사진 추가</span>
            <input type='file' accept='image/*' multiple onChange={handleImageUpload} style={{ display: 'none' }} />
          </label>
        )}
      </div>
    </div>
  );
};
